import React from "react";
import {useState, useEffect} from "react";

// Components
import Latest from "components/Screens/Fees/Common/FundTabs/LatestTab/Latest";
import Reports from "components/Screens/Fees/Common/FundTabs/ReportsTab/Reports";

// Styles
import DublinGlobalContainer from "./DublinGlobal.styles";
import SubTabs from "components/Common/SubTabs/SubTabs";
import Archive from "components/Screens/Fees/Common/FundTabs/ArchiveTab/Archive";

//utils
import {FeesReportDetails, setFeesReportDetails} from "utils/fees.utils";
import PowerBIDashboard from "../../../../components/Common/PowerBIDashboard";

interface DublinGlobalProps {
    region: string;
}

const DublinGlobal = ({ region }: DublinGlobalProps) => {
    const [feesForcastReportDetails, setFeesForcastReportDetails] =
        useState<FeesReportDetails>({ workspaceId: "", reportId: "" });
    const [feesDiscrepancyReportDetails, setFeesDiscrepancyReportDetails] =
        useState<FeesReportDetails>({ workspaceId: "", reportId: "" });
    const [feesMonthlyReportDetails, setFeesMonthlyReportDetails] =
        useState<FeesReportDetails>({ workspaceId: "", reportId: "" });

    useEffect(() => {
       setFeesReportDetails("DUBLIN_GLOBAL_FEES", setFeesForcastReportDetails);
       setFeesReportDetails("DUBLIN_GLOBAL_DISCREPANCY", setFeesDiscrepancyReportDetails);
       setFeesReportDetails("DUBLIN_GLOBAL_MONTHLY", setFeesMonthlyReportDetails);
    }, []);

    return (
        <DublinGlobalContainer>
            <SubTabs
                defaultTab="latest"
                subTabs={[
                    {
                        value: "latest",
                        title: "LATEST",
                        content: <Latest fund="dublin" region="global" period="latest" />,
                        permissions: ["p_can_view_fees", "p_can_action_fees"],
                    },
                    {
                        value: "reports",
                        title: "REPORTS SIGN OFF",
                        content: <Reports fund="dublin" region="global" />,
                        permissions: ["p_can_view_fees", "p_can_action_fees"],
                    },
                    {
                        value: "fee_report",
                        title: "FEE REPORT",
                        content: (
                            <div className="iframeContainer">
                                {feesForcastReportDetails.reportId && (
                                    <PowerBIDashboard
                                        reportId={
                                            feesForcastReportDetails.reportId
                                        }
                                        workspaceId={
                                            feesForcastReportDetails.workspaceId
                                        }
                                    ></PowerBIDashboard>
                                )}
                            </div>
                        ),
                        permissions: ["p_can_view_fees", "p_can_action_fees"],
                    },
                    {
                        value: "discrepancy_report",
                        title: "DISCREPANCY REPORT",
                        content: (
                            <div className="iframeContainer">
                                {feesDiscrepancyReportDetails.reportId && (
                                    <PowerBIDashboard
                                        reportId={
                                            feesDiscrepancyReportDetails.reportId
                                        }
                                        workspaceId={
                                            feesDiscrepancyReportDetails.workspaceId
                                        }
                                    ></PowerBIDashboard>
                                )}
                            </div>
                        ),
                        permissions: ["p_can_view_fees", "p_can_action_fees"],
                    },
                    {
                        value: "monthly_report",
                        title: "MONTHLY NAV REPORT",
                        content: (
                            <div className="iframeContainer">
                                {feesMonthlyReportDetails.reportId && (
                                    <PowerBIDashboard
                                        reportId={
                                            feesMonthlyReportDetails.reportId
                                        }
                                        workspaceId={
                                            feesMonthlyReportDetails.workspaceId
                                        }
                                    ></PowerBIDashboard>
                                )}
                            </div>
                        ),
                        permissions: ["p_can_view_fees", "p_can_action_fees"],
                    },
                    {
                        value: "archive",
                        title: "ARCHIVE",
                        content: <Archive fund="dublin" region="global" />,
                        permissions: ["p_can_view_fees", "p_can_action_fees"],
                    },
                ]}
            />
        </DublinGlobalContainer>
    );
};
export default DublinGlobal;
